// extracted by mini-css-extract-plugin
export var equalColumn = "_go-0";